import { RgCreate as W, RG_TYPE as y } from "@project-rouge/rg-core";
import { Vector3 as k, MathUtils as v } from "three";
import { getLineDirection as O } from "../../geometry-utils/core/index8.js";
import { rotateAroundY as T } from "../../geometry-utils/core/index23.js";
import { getEuler as G } from "../../geometry-utils/three/index7.js";
import { getPolySizeAndPos as S } from "../../utils/index15.js";
import { SignedAngle as Y } from "../../utils/index32.js";
import { createRgObjectsOnLines as j } from "../boundary/index.js";
import { getLevelBoundary as C } from "../boundary/index6.js";
import { getLevelOuterBoundary as F } from "../boundary/index7.js";
function D({ building: e, roofLevels: t, parapetModId: l = void 0, parapetHeight: c = 1, roofModId: p = void 0, facadeModId: i = void 0, rvDataList: r = void 0 }) {
  if (e.data.levels.length === 0)
    throw new Error("Roof could not be created, Building has no levels!");
  for (const n of t)
    H(e, n, l, c, p, i, r);
}
function H(e, t, l, c = 1, p, i, r) {
  let n;
  p && r && (n = r.find((o) => o.modulousId === p));
  const m = n && n.size ? n.size[1] : 0.5;
  let s;
  l && r && (s = r.find((o) => o.modulousId === l));
  const z = s && s.size ? s.size[2] : 0.135, I = new k(1, 0, 0).applyEuler(G(e)).normalize(), u = C(e, t), h = [0.5, 0, 0.5], a = S(u, h, t.floorWorldBottom, m), R = W({
    name: "roof",
    type: y.Roof,
    pos: a.pos,
    anchor: h,
    size: a.size,
    modulousId: n ? n.modulousId : "",
    children: [],
    data: {
      level: t.levelIndex,
      levelId: t.uuid,
      polygon: u.map((o) => [o[0] - a.pos[0], 0, o[2] - a.pos[2]])
    }
  }, r || []);
  e.children.push(R);
  const f = i && r ? r.find((o) => o.modulousId === i) : void 0, x = f && f.totalThickness ? f.totalThickness : 0.3, A = F(e, t, x, !0), g = j({
    lines: A,
    thickness: z,
    height: c - m,
    partial: {
      children: [],
      type: y.Parapet,
      modulousId: s ? s.modulousId : "",
      name: "parapet",
      data: { level: t.levelIndex, levelId: t.uuid }
    },
    rvDataList: r
  });
  for (let o = 0; o < g.length; o++) {
    const d = g[o], B = O(A[o]);
    d.pos[1] = t.floorWorldBottom + m;
    const P = T([d.pos], e.pos, e.rot[1])[0];
    d.pos = P.map((w, E) => w - e.pos[E]), d.rot = [0, -Y(B, I) * v.RAD2DEG, 0], e.children.push(d);
  }
}
export {
  D as createRoofAndParapet
};
//# sourceMappingURL=index.js.map
